export default {
  male: 1800,
  female: 1500,
  maleMax: 2200,
  femaleMax: 1800,
};
